const { Mixin } = require('hops-mixin');
const {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} = require('redux');
const { GLOBAL_REDUCERS } = require('./reducers');

const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

class HopsCompatRuntimeMixin extends Mixin {
  constructor(config, element, options = {}) {
    super(config, element, options);

    const { redux: { reducers = {} } = {} } = options;

    this.reducers = {
      ...GLOBAL_REDUCERS,
      ...reducers,
    };
  }

  getReduxStore() {
    if (this.store) {
      return this.store;
    }

    const combinedReducers = combineReducers(this.reducers);

    if (module.hot) {
      this.store =
        global.store || (global.store = this._createStore(combinedReducers));
      this.store.replaceReducer(combinedReducers);
    } else {
      this.store = this._createStore(combinedReducers);
    }

    return this.store;
  }

  _createStore(combinedReducers) {
    const middlewares = this.getReduxMiddlewares().map((middleware) =>
      applyMiddleware(middleware)
    );

    return createStore(
      combinedReducers,
      global.REDUX_STATE,
      composeEnhancers(...middlewares)
    );
  }
}

module.exports = HopsCompatRuntimeMixin;
